import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Styles/UpdateSkills12.css";

import eventImage1 from "../../assets/upskills.png";
import eventImage2 from "../../assets/UpdateSkills3.png";
import skills from "../../assets/skills.mp4";

import ServiceupdateSkillsRgister from "../../components/ServiceUpdateSkillsRegister";

const UpdateSkills = () => {
  const programs = [
    {
      title: "Digital Marketing",
      category: "Marketing",
      trainer: "K. Rajashekhar",
      trainingMode: "Virtual",
      schedule: "Sep 20 - Oct 30",
      time: "10AM - 2PM",
      location: "Ameerpet",
      image: eventImage1,
    },
    {
      title: "Digital Marketing",
      category: "Marketing",
      trainer: "K. Rajashekhar",
      trainingMode: "Virtual",
      schedule: "Sep 20 - Oct 30",
      time: "10AM - 2PM",
      location: "Ameerpet",
      image: eventImage2,
    },
  ];

  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <section className="update1234-wrapper" id="UpdateSkills">

    <div className="update1234-section">

        <div className="update1234-hero">

            {/* VIDEO LEFT */}
            <div className="update1234-hero-video">

                <div className="update1234-video-container">

                    <video
                        src={skills}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="update1234-video"
                    />

                </div>

            </div>


            {/* CONTENT RIGHT */}
            <div className="update1234-hero-content">

                <h1 className="update1234-title">
                    UPDATE SKILLS & TRAINING
                </h1>

                <div className="update1234-title-line"></div>

                <p className="update1234-description">
                    We deliver skill-enhancement and training programs
                    designed to build stronger, smarter, and more capable
                    teams. Our learning modules focus on real-world
                    applications, continuous improvement, and
                    industry-relevant expertise.
                </p>

                <p className="update1234-description update1234-description-second">
                    Through structured training sessions, expert guidance,
                    and hands-on practice.
                </p>

            </div>

        </div>


        {/* =================================================
            PROGRAM CARDS
        ================================================= */}

        <div className="update1234-program-list">

            <div className="update1234-grid">

                {programs.map((program, index) => (

                    <div
                        className="update1234-card"
                        key={index}
                    >

                        {/* IMAGE */}
                        <div className="update1234-card-image-wrapper">

                            <img
                                src={program.image}
                                alt={program.title}
                                className="update1234-card-image"
                            />

                        </div>


                        {/* CONTENT */}
                        <div className="update1234-card-content">

                            <h3 className="update1234-card-title">
                                {program.title}
                            </h3>

                            <div className="update1234-card-title-line"></div>


                            {/* CATEGORY */}
                            <div className="update1234-detail">

                                <span className="update1234-detail-icon">
                                    📚
                                </span>

                                <span className="update1234-detail-text">

                                    <span className="update1234-detail-label">
                                        Program Category:
                                    </span>

                                    <strong>
                                        {program.category}
                                    </strong>

                                </span>

                            </div>


                            {/* TRAINER */}
                            <div className="update1234-detail">

                                <span className="update1234-detail-icon">
                                    👨‍🏫
                                </span>

                                <span className="update1234-detail-text">

                                    <span className="update1234-detail-label">
                                        Trainer/Host:
                                    </span>

                                    <strong>
                                        {program.trainer}
                                    </strong>

                                </span>

                            </div>


                            {/* TRAINING MODE */}
                            <div className="update1234-detail">

                                <span className="update1234-detail-icon">
                                    💻
                                </span>

                                <span className="update1234-detail-text">

                                    <span className="update1234-detail-label">
                                        Training Mode:
                                    </span>

                                    <strong>
                                        {program.eventmode}
                                    </strong>

                                </span>

                            </div>


                            {/* SCHEDULE */}
                            <div className="update1234-detail">

                                <span className="update1234-detail-icon">
                                    📅
                                </span>

                                <span className="update1234-detail-text">

                                    <span className="update1234-detail-label">
                                        Schedule:
                                    </span>

                                    <strong>
                                        {program.schedule}
                                    </strong>

                                </span>

                            </div>


                            {/* TIME */}
                            <div className="update1234-detail">

                                <span className="update1234-detail-icon">
                                    🕐
                                </span>

                                <span className="update1234-detail-text">

                                    <span className="update1234-detail-label">
                                        Time:
                                    </span>

                                    <strong>
                                        {program.time}
                                    </strong>

                                </span>

                            </div>


                            {/* LOCATION */}
                            <div className="update1234-detail">

                                <span className="update1234-detail-icon">
                                    📍
                                </span>

                                <span className="update1234-detail-text">

                                    <span className="update1234-detail-label">
                                        Location:
                                    </span>

                                    <strong>
                                        {program.location}
                                    </strong>

                                </span>

                            </div>


                            {/* REGISTER */}
                            <button
                                className="update1234-register-btn"
                                onClick={openPopup}
                            >

                                REGISTER NOW

                                <span className="update1234-register-arrow">
                                    →
                                </span>

                            </button>

                        </div>

                    </div>

                ))}

            </div>

        </div>

    </div>

</section>


      {/* =====================================================
          REGISTRATION POPUP
      ===================================================== */}

      <ServiceupdateSkillsRgister
        show={showPopup}
        onClose={closePopup}
      />

    </>
  );
};

export default UpdateSkills;